import StreetParkingAutopay from 'feature/street-parking/street-parking-autopay/street-parking-autopay';

export default StreetParkingAutopay;
